import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/api";
import { useLang } from "@/i18n";
import { BackHome } from "@/components/BackHome";

export default function ResetPassword() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative">
      <BackHome />
      <div className="w-full max-w-md kc-card p-8" data-testid="reset-password-card">
        <h1 className="text-3xl font-black uppercase tracking-tight mb-6">{t("reset.title")}</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">{t("login.password")}</label>
            <input data-testid="reset-password-input" type="password" required minLength={6} value={password}
              onChange={(e) => setPassword(e.target.value)} className="kc-input mt-1" />
          </div>
          {error && <p data-testid="reset-error" className="text-sm text-destructive">{error}</p>}
          <button data-testid="reset-submit-button" type="submit" disabled={loading || !token} className="kc-btn-primary w-full">
            {loading ? t("common.loading") : t("reset.submit")}
          </button>
        </form>
        <Link data-testid="back-to-login-link" to="/login" className="block mt-5 text-sm text-muted-foreground hover:text-foreground">
          {t("forgot.back")}
        </Link>
      </div>
    </div>
  );
}
